<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width='600px')
      v-card
        v-card-text.px-3.pt-3.pb-1
          v-card(v-if="resizeImageFileUrl" flat)
            div(align="center")
              v-img(:src="resizeImageFileUrl" aspect-ratio="1" width="202")
          v-card(v-else outlined height="203" :style="{ 'background-color': $vuetify.theme.themes[$theme].primaryT08 }")
            div.fill-height
              div.d-flex.justify-center.align-end(style="height: 70%")
                div
                  div.mb-2(align="center")
                    eva-icon(name="image-outline" :fill="$vuetify.theme.themes[$theme].primaryT32" height="38" width="38")
                  div.file-layout.mb-4
                    v-btn.button-AA-tiny(color="textColorAccent" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}") upload
                    input.input-layout(type="file" @change="onFileChange" accept="image/*" style="width: 60px !important")
              div.d-flex.justify-center.align-end(style="height: 30%")
                div.mb-4
                  div.c1.basic600--text.text-center Max filesize 10 MB

          div.d-flex.justify-center.mt-2(v-if="resizeImageFileUrl")
            div.file-layout
              v-btn.button-Aa-tiny.custom-transform-class.text-none.px-2(color="textColorAccent" text small)
                eva-icon.mr-2(name="edit-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" height="12" width="12" style="margin-top: 1px")
                | Change image
              input.input-layout(type="file" @change="onFileChange" accept="image/*" style="width: 104px !important")

        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-small.primary400--text Cancel
          v-btn.mr-2(color='textColorAccent' depressed height=32 @click="clickSave" :loading="isLoading" dark)
            .button-AA-small.basic100--text {{ $t('add') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { resizeImage } from '@/utils'

export default {
  name: 'AddNewImageDialog',
  props: ['open', 'expenseId'],
  data: () => ({
    resizeImageFileUrl: '',
    resizeImageFile: null,
    isLoading: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickSave() {
      if (!this.resizeImageFile) {
        this.showMessage(['error', this.$t('error_message.image_file_is_required')])
        return
      }
      this.isLoading = true
      var params = new FormData()
      const docType = 'invoice'
      params.append('doc_type', docType)
      params.append('file', this.resizeImageFile)
      this.axios.post(`/books/${this.company.slug}/expenses/${this.expenseId}/documents?doc_type=${docType}`, params)
        .then(resp => {
          this.showModal = false
          this.showMessage(['success', this.$t('success_message.image_added')])
          this.$emit('added', resp.data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async onFileChange (e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      const resizedImage = await resizeImage(files[0], 'product_image.jpeg')
      this.resizeImageFileUrl = resizedImage.dataURL
      this.resizeImageFile = resizedImage.file
    }
  }
}
</script>

<style scoped>
.container-image {
  border-style: solid;
  border-width: 1px;
  border-color: grey;
  border-radius: 2px;
}
.file-layout {
  position: relative;
}
.input-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
.background-inventory {
  border-style: solid;
  border-width: 1px;
  border-color: grey;
  border-radius: 2px;
}
</style>

<i18n>
{
  "en": {
    "product_image": "Product Image",
    "upload": "Upload",
    "edit": "Edit",
    "details": "Details",
    "product_name": {
      "label": "Name",
      "placeholder": "Write product name here"
    },
    "price": {
      "label": "Price",
      "placeholder": "0"
    },
    "weight": {
      "label": "Weight",
      "placeholder": "Min = 0.1 kg | Max = 60 kg"
    },
    "description": {
      "label": "Description",
      "placeholder": "Write product description here"
    },
    "has_inventory": "Has Inventory",
    "no_inventory": "No Inventory",
    "quantity": {
      "label": "Quantity",
      "placeholder": "How many stock left"
    },
    "whos_selling": "Who's Selling",
    "new": "New",
    "add": "Add",
    "save": "Save"
  }
}
</i18n>
